import {combineReducers} from "redux";
import generalProbability from "./generalProbability";
import probabilityByDraw from "./probabilityByDraw";
import manageProbabilityType from "./manageProbabilityType";

const protectConfigReducer = combineReducers({
    generalProbability,
    probabilityByDraw,
    manageProbabilityType

});
export default protectConfigReducer;